import { useState } from "react";
import Form from "../../../components/common/form/Form";
import { hasPermission } from "../../../helpers/utils/AccessControlUtils";
import CannedNoteSelector from "./CannedNoteSelector";
import CustomNoteSection from "./CustomNoteSection";
import Modal from "../../../components/common/form/Modal";
import ButtonTray from "../../../components/common/form/ButtonTray";

interface CommonNoteModalProps {
    targetCert?: any;
    setTargetCert?: any;
    noteBody: any;
    setNoteBody: any;
    type?: string | null;
    bold?: boolean | null;
    setBold?: (val: boolean) => void;
    saveAsCanned?: boolean | null;
    setSaveAsCanned?: (val: boolean) => void;
    handleSubmit?: any;
    dismissModal?: any;
    disable?: any;
    btnName?: string;
    formNoteType?: string;
    isFulfillmentNotes?: boolean;
    isExternalInternal?: boolean;
    external?: boolean | null;
    setExternal? : any;
    accountNumber?: string | null;
    setAccountNumber?: any;
    parentAccountData?: any;
    yellowHighlight?: boolean | null;
    setYellowHighlight?: (val: boolean) => void;
    redColor?: boolean | null;
    setRedColor?: (val: boolean) => void;
    isCertificateNote?: boolean;
    sort?: any;
    setSort?: any;
    show?: any
    setShow?: any
    title?: any,
    isLoading?: any,
    onSubmit?: any
}

export default function CommonNoteModal({
    targetCert,
    setTargetCert,
    noteBody,
    setNoteBody,
    type = null,
    bold = null,
    setBold,
    saveAsCanned,
    setSaveAsCanned,
    show,
    setShow,
    title = "",
    formNoteType = "TAX",
    isFulfillmentNotes = false,
    isExternalInternal = false,
    external = null,
    setExternal,
    accountNumber = null,
    setAccountNumber,
    parentAccountData = null,
    yellowHighlight = null,
    setYellowHighlight,
    redColor = null,
    setRedColor,
    isCertificateNote = false,
    sort = null,
    setSort,
    isLoading,
    onSubmit,
    btnName

}: CommonNoteModalProps) {

    const [cannedNoteType, setCannedNoteType] = useState<string>("Canned");

    // @ts-ignore
    return (
        <>
            <Modal
                title={title}
                show={show}
                setShow={setShow}
                className={"w-3/6 bg-text-0 text-surface-0"}
                hoa={formNoteType !== 'TAX'}
                fields={
                    <>

                        <div className="modal-body">
                            {hasPermission(["CANNOTE-R"]) && (
                                <div className="form-group row">
                                    <div className="">
                                        <div className={formNoteType === 'TAX' ? "flex border-b-2 border-highlight-5" : "flex border-b-2 border-text-4"}>
                                            <button
                                                type='button'
                                                className={cannedNoteType === 'Canned'
                                                    ? (formNoteType === 'TAX' && cannedNoteType === 'Canned')
                                                        ? "bg-[steelblue] text-[white]  rounded-t-[5px] rounded-b-none p-[10px] w-[120px] "
                                                        : "bg-text-4 text-[white] rounded-t-[5px] rounded-b-none  p-[10px] w-[120px]"
                                                    : "bg-transparent text-[black] rounded-t-[5px] rounded-b-none  p-[10px] w-[120px]"}
                                                onClick={() => setCannedNoteType('Canned')}
                                            >
                                                Canned
                                            </button>
                                            <button
                                                type='button'
                                                className={cannedNoteType === 'Canned'
                                                    ? "bg-transparent text-[black] ml-5"
                                                    : (formNoteType === 'TAX' && cannedNoteType !== 'Canned')
                                                        ? "bg-[steelblue] text-[white] rounded-t-[5px] rounded-b-none  p-[10px] w-[120px]"
                                                        : "bg-text-4 text-[white] rounded-t-[5px] rounded-b-none  p-[10px] w-[120px]"}
                                                onClick={() => setCannedNoteType('Custom')}
                                            >
                                                Custom
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}



                            {cannedNoteType === 'Canned' && hasPermission(["CANNOTE-R"]) ? (
                                <CannedNoteSelector
                                    setNoteBody={setNoteBody}
                                    bold={bold}
                                    setBold={setBold}
                                    formNoteType={formNoteType}
                                    type={type}
                                    cannedNoteType={cannedNoteType}
                                    setYellowHighlight={setYellowHighlight}
                                    setRedColor={setRedColor}
                                />
                            ) : (
                                <CustomNoteSection
                                    noteBody={noteBody}
                                    setNoteBody={setNoteBody}
                                    bold={bold}
                                    setBold={setBold}
                                    saveAsCanned={saveAsCanned}
                                    setSaveAsCanned={setSaveAsCanned}
                                    isExternalInternal={isExternalInternal}
                                    external={external}
                                    setExternal={setExternal}
                                    isFulfillmentNotes={isFulfillmentNotes}
                                    accountNumber={accountNumber}
                                    setAccountNumber={setAccountNumber}
                                    parentAccountData={parentAccountData}
                                    yellowHighlight={yellowHighlight}
                                    setYellowHighlight={setYellowHighlight}
                                    redColor={redColor}
                                    setRedColor={setRedColor}
                                    isCertificateNote={isCertificateNote}
                                    sort={sort}
                                    setSort={setSort}
                                    targetCert={targetCert}
                                    setTargetCert={setTargetCert}
                                />
                            )}
                        </div>
                        <div className="border-t border-text-1 mt-3 ">
                            <ButtonTray
                                buttons={[
                                    {
                                        buttonProps: {
                                            btnText: "Cancel",
                                            onClick: () =>{  setShow(false)
                                                setNoteBody("")
                                            },
                                            type: "cancel",
                                            isHoa: formNoteType === "HOA"
                                        },
                                        buttonType: "button"

                                    },
                                    {
                                        buttonProps: {
                                            btnText: `${btnName}  Note`,
                                            onClick: async (e: any) => {
                                                e.preventDefault()
                                                await onSubmit(e)
                                                setShow(false)
                                            },
                                            type: "submit",
                                            isLoading: isLoading,
                                            isHoa: formNoteType === "HOA"

                                        },
                                        buttonType: "button",

                                    }
                                ]}
                                align={"end"}
                                gap={2}
                            />

                        </div>
                    </>


                }
            />
        </>
    );
}